module.exports = "pegasus_template/assets/styleGroup1-facebook.gif";